module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-6-8d16ecdef43e824fe22771814288bd59.jpg";